/**
    商品列表
**/
<template>
     <div class="header_logo">
        <el-menu
             background-color="#78b942"
             mode="horizontal"
             router
             class="el-menu-vertical-demo">
                 <el-menu-item>
					 <div class="box" @click="$router.push('/')">
						<div class="houtai">爱 锋 派</div>
						<div class="bot">IPHONEPAI COMPASS</div>
					 <!-- <img class="xunyouText" :src="require('@/assets/img/xunyouText.png')" @click="$router.push('/')" alt=""> -->
					 </div>
					</el-menu-item>
                 <el-menu-item v-for="item in leftMenu" :key="item.id" :index="item.url">
                     <template slot="title"><i :class="item.icon"></i>{{item.menu}}</template>                        
                 </el-menu-item>            
         </el-menu>
         <div class="middle">
             <router-view></router-view>
         </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
        leftMenu:[
            {
                id:1,
                menu:'商城首页',
                url:'/',
                icon:'el-icon-s-home'
            },
            {
                id:2,
                menu:'用户中心',
                url:'/userCenter',
                icon:'el-icon-user'
            }, 
            {
                id:3,
                menu:'支付中心',
                url:'/paymentCenter',
                icon:'el-icon-coin'
            },
        ],
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
  },
};
</script>

<style scoped lang="less">
.header_logo{
    height: 100%;
	.box{
		height: 60px;
		text-align: center;
	}
    .xunyouText{
        width: 100px;
        height: auto;
    }
	.houtai{
		font-size: 28px;
		font-weight: 600;
		line-height: 30px;
		margin-top: 10px;
	}
	.bot{
		font-size: 10px;
		line-height: 12px;
	}
    li.el-menu-item {
        color: white !important;
        font-size: 16px;
        i{
            color: white;
            vertical-align: inherit;
        }
    }
    .middle{
        height: 100% !important;
        background: url("~@/assets/img/userCenterbg.jpg") no-repeat;
        background-repeat: no-repeat;
        background-size: cover;
    }

}
.breakcrumbHeader {
  margin: 15px 0;
}
// .leftaside.el-col.el-col-6 {
//     background: white;
//     padding: 30px;
//     box-sizing: border-box;
//     .el-menu{
//         border-right:0px;
//         li.el-menu-item-group {
//             margin-bottom: 15px;
//         }
//     }
//     /deep/ .el-menu-item-group__title {
//             padding: 7px 0 10px 20px;
//             line-height: normal;
//             font-size: 14px;
//             color: #333;
//         }
//     li.el-menu-item {
//         height: 24px;
//         line-height: 24px;
//         font-size: 12px;        
//     }
//     .el-menu-item:focus, .el-menu-item:hover {
//         outline: 0;
//         background-color: transparent;
//     }
//     .el-menu-item.is-active {
//         color: #78b942;
//     }
// }


</style>

 
 

 


// WEBPACK FOOTER //
// src/views/siteNavigation/siteNavigation.vue